module.exports = __webpack_public_path__ + "static/media/2 (53).39a9f207.jpg";